import api from '.'

export const stages = {
  get (id, success, fail) {
    api.authenticatedRequest('GET', `/stages/${id}`, null, success, fail)
  },
  getWithFormat (id, format, success, fail) {
    api.authenticatedRequest('GET', `/stages/${id}?format=${format}`, null, success, fail)
  },
  getWithFormatAndResponse (id, format, responseId, success, fail) {
    api.authenticatedRequest('GET', `/stages/${id}?format=${format}&response=${responseId}`, null, success, fail)
  },
  getPoll (id, success, fail, token, consentToken) {
    const params = new URLSearchParams()
    if (token) params.set('token', token)
    if (consentToken) params.set('consentToken', consentToken)
    const q = params.toString() ? `?${params.toString()}` : ''
    api.unauthenticatedRequest('GET', `/participants/stages/${id}/public${q}`, null, success, fail)
  },
  submitPollData (id, data, success, fail) {
    api.unauthenticatedRequest('POST', `/participants/stages/${id}/public/responses`, data, success, fail)
  },
  requestPollVerification (id, method, data, success, fail) {
    api.unauthenticatedRequest('POST', `/participants/stages/${id}/public/verifications/${method}`, data, success, fail)
  },
  verifyPollVerification (id, method, data, success, fail) {
    api.unauthenticatedRequest('POST', `/participants/stages/${id}/public/verifications/${method}/verify`, data, success, fail)
  },
  update (id, data, success, fail) {
    api.authenticatedRequest('PUT', `/stages/${id}`, data, success, fail)
  },
  delete (id, success, fail) {
    api.authenticatedRequest('DELETE', `/stages/${id}`, null, success, fail)
  },
  deleteBulk (ids, success, fail) {
    api.authenticatedRequest('DELETE', `/stages?ids=${ids.join(',')}`, null, success, fail)
  },
  getForParticipant (id, success, fail) {
    api.authenticatedRequest('GET', `/stages/${id}/participate`, null, success, fail)
  }
}
